import { BrowserRouter, MemoryRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import TentangPage from './pages/TentangPage';
import LokasiPage from './pages/LokasiPage';
import KontakPage from './pages/KontakPage';
import FaqPage from './pages/FaqPage';
import NotFoundPage from './pages/NotFoundPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu/" element={<MenuPage />} />
        <Route path="/tentang/" element={<TentangPage />} />
        <Route path="/lokasi/" element={<LokasiPage />} />
        <Route path="/kontak/" element={<KontakPage />} />
        <Route path="/faq/" element={<FaqPage />} />
        <Route path="/menu" element={<Navigate to="/menu/" replace />} />
        <Route path="/tentang" element={<Navigate to="/tentang/" replace />} />
        <Route path="/lokasi" element={<Navigate to="/lokasi/" replace />} />
        <Route path="/kontak" element={<Navigate to="/kontak/" replace />} />
        <Route path="/faq" element={<Navigate to="/faq/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export function PrerenderApp({ path }) {
  return (
    <MemoryRouter initialEntries={[path]}>
      <AppRoutes />
    </MemoryRouter>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
